import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import BlankImage from "../../assets/blank.png";
import {
  setActiveLanguage,
  getLanguages,
  getActiveLanguage
} from "react-localize-redux";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";
import { toggleModal, getModalStatus } from "../../store/common";

const LanguageSelector = ({
  languages,
  setActiveLanguage,
  currentLanguage,
  getLanguageDropdownStatus,
  toggleModal
}) => (
  <Dropdown isOpen={getLanguageDropdownStatus} toggle={() => {}}>
    <DropdownToggle
      color="link"
      onClick={() => toggleModal("language", getLanguageDropdownStatus)}
    >
      <img
        src={BlankImage}
        className={"flag flag-" + currentLanguage}
        alt={currentLanguage}
      />
    </DropdownToggle>
    <DropdownMenu>
      {languages.map(language => (
        <DropdownItem
          active={language.code === currentLanguage}
          key={language.code}
          onClick={() => {
            setActiveLanguage(language.code);
            toggleModal("language", getLanguageDropdownStatus);
          }}
        >
          <img
            src={BlankImage}
            className={"flag flag-" + language.code}
            alt={language.name}
          />{" "}
          {language.name}
        </DropdownItem>
      ))}
    </DropdownMenu>
  </Dropdown>
);

LanguageSelector.propTypes = {
  languages: PropTypes.string,
  setActiveLanguage: PropTypes.func,
  currentLanguage: PropTypes.string,
  getLanguageDropdownStatus: PropTypes.string,
  toggleModal: PropTypes.func
};

const mapStateToProps = state => ({
  languages: getLanguages(state.locale),
  currentLanguage: getActiveLanguage(state.locale).code,
  getLanguageDropdownStatus: getModalStatus(
    state.common.modals ? state.common.modals.language : null
  )
});
const mapDispatchToProps = dispatch => ({
  setActiveLanguage: code => dispatch(setActiveLanguage(code)),
  toggleModal: (modalName, action) => dispatch(toggleModal(modalName, !action))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LanguageSelector);



// WEBPACK FOOTER //
// ./src/molecules/containers/LanguageSelector.js